export * from "./Tooltip.settings";
